var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Periods } from '@shared/utils/History/TFInfo';
import { ProcessorWorker } from './ProcessorWorker';
import * as vendorMessage from './Messages/MessagesImport';
import * as vendorGroup from './Groups/GroupsImport';
import { FieldsFactory } from './Factory/FieldsFactory';
import { HistoryType } from '@shared/utils/History/HistoryType';
import { Connection } from '@shared/commons/Connection';
import { Message } from '@shared/utils/DirectMessages/Message';
import { BaseInterval } from '@shared/utils/History/BaseInterval';
import { BaseIntervalInputParams } from '@shared/utils/History/BaseIntervalInputParams';
import { ChartDataType } from '@front/chart/Utils/ChartConstants';
import { HistoryTypeConverter } from '@shared/utils/History/HistoryTypeConverter';
export class HistoryProcessorWorker extends ProcessorWorker {
    constructor() {
        super(ProcessorWorker.MODE_HISTORYSTREAM);
        this.PrevBars = [];
    }
    SendRequestToServer(historyParams, routeId, signal) {
        const _super = Object.create(null, {
            SendMessage: { get: () => super.SendMessage }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.signal = signal;
            return yield new Promise((resolve, reject) => {
                var _a, _b;
                this.promiseResolver = resolve;
                this.historyParams = historyParams;
                const tfInfo = historyParams.TimeFrameInfo;
                const histReqMessage = new vendorMessage.PFixHistroryRequestMessage();
                ProcessorWorker.AddProtocolVersonAndMaxField(histReqMessage);
                if (historyParams.IsContinuous) {
                    histReqMessage.setFieldValue(FieldsFactory.FIELD_INSTRUMENT_ID, historyParams.InstrumentID);
                }
                else {
                    histReqMessage.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, historyParams.InstrumentTradableID);
                }
                const aggregateByServer = this.isSupportedByServer(tfInfo);
                historyParams.ShouldCheckAggregatedPeriods = aggregateByServer;
                const period = tfInfo.Periods;
                const basePeriod = aggregateByServer ? period : Periods.GetBasePeriod(period);
                const serverPeriod = Periods.TranslateToServerPeriod(basePeriod);
                histReqMessage.setFieldValue(FieldsFactory.FIELD_HISTORY_PERIOD_TYPE, serverPeriod);
                histReqMessage.setFieldValue(FieldsFactory.FIELD_BARS_TYPE, HistoryTypeConverter.GetServerHistoryType(tfInfo.HistoryType));
                histReqMessage.setFieldValue(FieldsFactory.FIELD_USER_ID, parseInt(historyParams.userId));
                histReqMessage.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, parseInt(historyParams.userPin));
                histReqMessage.setFieldValue(FieldsFactory.FIELD_ROUTE_ID, parseInt(this.FMsgDecoder.GetRouteQuoteId(routeId)));
                // История по дате
                if (!isNullOrUndefined(historyParams.FromTime)) {
                    histReqMessage.setFieldValue(FieldsFactory.FIELD_START_TIME, historyParams.FromTime);
                }
                if (!isNullOrUndefined(historyParams.ToTime)) {
                    histReqMessage.setFieldValue(FieldsFactory.FIELD_END_TIME, historyParams.ToTime);
                }
                // TODO
                histReqMessage.setFieldValue(FieldsFactory.FIELD_MODE, ProcessorWorker.SOKET_MESSAGE_MODE_NEW_FORMAT);
                const barsCount = this.getRealBarCount(historyParams.count, period, aggregateByServer);
                if (isValidNumber(barsCount)) {
                    histReqMessage.setFieldValue(FieldsFactory.FIELD_QUOTES_LIMIT, barsCount);
                }
                const rightBarsCount = this.getRealBarCount(historyParams.rightBarsCount, period, aggregateByServer);
                if (isValidNumber(rightBarsCount)) {
                    histReqMessage.setFieldValue(FieldsFactory.FIELD_QUOTES_LIMIT_RIGHT, rightBarsCount);
                }
                histReqMessage.setFieldValue(FieldsFactory.FIELD_SORT_ORDER, historyParams.sortOrder);
                histReqMessage.setFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN, Connection.ConnectResultData.ConnectParams.accessToken);
                // currently it is applyed only for aggregated history
                const onlyMainSession = (_b = (_a = tfInfo.SessionInfo) === null || _a === void 0 ? void 0 : _a.OnlyMainSession) !== null && _b !== void 0 ? _b : true;
                histReqMessage.setFieldValue(FieldsFactory.FIELD_SHOW_EXTENDED_SESSION, !onlyMainSession);
                const rqi = histReqMessage.getSequance();
                histReqMessage.setRequestId(rqi);
                _super.SendMessage.call(this, histReqMessage);
            });
        });
    }
    ParseHistory(message, historyParams) {
        var _a, _b, _c;
        message = message[0] || message;
        // refused
        if (message.IsDirect && message.Code === Message.CODE_BUSINESS_REJECT_MESSAGE) {
            if (message.BusinessRejectCode ===
                vendorMessage.BusinessRejectMessage.ERROR_SERVER_HISTORY_QUEUE_WAS_OVERFLOWED) {
                super.Notify(message);
            }
            this.promiseResolver([]);
            return;
        }
        if ((_a = this.signal) === null || _a === void 0 ? void 0 : _a.aborted) {
            this.CancelHistoryRequest();
        }
        const respEnd = message.FieldSet.GetField(FieldsFactory.FIELD_RESPONCE_END);
        const end = !!(respEnd === null || respEnd === void 0 ? void 0 : respEnd.Value);
        const rqi = message.FieldSet.GetField(FieldsFactory.FIELD_REQUEST_ID);
        const reqID = rqi.Value;
        // TODO TranslateToParsePeriod ?????????
        const bars = this.ReadBarToBaseInterval(message.FieldSet.GetGroups(FieldsFactory.QUOTE_BAR_GROUP, vendorGroup.PfixQuoteBarGroup), historyParams);
        let PrevBars = this.PrevBars;
        // When we use a query relative to the middle date, the middle date bar will be duplicated in the two responses
        if (((_b = PrevBars[0]) === null || _b === void 0 ? void 0 : _b.FLeftTimeTicks) === ((_c = bars[0]) === null || _c === void 0 ? void 0 : _c.FLeftTimeTicks)) {
            PrevBars.shift();
        }
        PrevBars = bars.concat(PrevBars);
        if (end) {
            // зачем сортировать?? сервер возвращает сортированные бары
            // Возможно нужно будет развернуть массив
            // Смотря как запрашивали
            this.promiseResolver(PrevBars.sort(BaseInterval.CompareTo));
        }
        this.PrevBars = PrevBars;
    }
    ReadBarToBaseInterval(quoteBarGroup, historyParams) {
        var _a;
        const result = [];
        if (quoteBarGroup == null) {
            return result;
        }
        const tfInfo = historyParams.TimeFrameInfo;
        const historyType = historyParams.TimeFrameInfo.HistoryType;
        const aggregateByServer = this.isSupportedByServer(tfInfo);
        const period = aggregateByServer ? tfInfo.Periods : Periods.TranslateToParsePeriod(tfInfo.Periods);
        // const isNeedCorrectBorders :boolean = aggregateByServer && instrument != null && Periods.IsBarAggregation(period);
        let needControlLeftBorder = false;
        let notTick = false;
        const bhL = quoteBarGroup.length;
        for (let i = 0; i < quoteBarGroup.length; i++) {
            if ((_a = this.signal) === null || _a === void 0 ? void 0 : _a.aborted) {
                this.CancelHistoryRequest();
            }
            const biObj = this.getBarInputParamsFromQuoteBarGroup(quoteBarGroup[i], period, historyType);
            const bi = new BaseInterval(biObj, period);
            if (i === 0) {
                needControlLeftBorder = bi.FLeftTimeTicks <= 0;
                notTick = bi.Data.length >= 4;
            }
            if (needControlLeftBorder && bi.FLeftTimeTicks <= 0) {
                historyParams.count--;
                console.warn(`ExpandHistory: bi.FLeftTimeTicks <= 0 (Invalid time ${bi.LeftTime})`);
                continue;
            }
            const prevBi = i + 1 < bhL && i > 0 ? result[i - 1] : null;
            if (notTick && prevBi != null && bi.FLeftTimeTicks === prevBi.FLeftTimeTicks) {
                historyParams.count--;
                console.warn(`ExpandHistory: has duplicate bar (Invalid time ${bi.LeftTime})`);
                continue;
            }
            if (!bi.IsValid()) {
                historyParams.count--;
                console.warn(`ExpandHistory: !bi.IsValid (Invalid time ${bi.LeftTime})`);
                continue;
            }
            result.push(bi);
        }
        return result;
    }
    MergeBIDASKAVG(bids, asks, historyParams) {
        const res = [];
        let askIndex = 0;
        const args = new Array(7);
        const biObj = new BaseIntervalInputParams();
        for (let i = 0; i < bids.length; i++) {
            const bidBi = bids[i];
            if (historyParams.TimeFrameInfo.Periods == Periods.TIC) {
                biObj.LeftTimeTicks = bidBi.FLeftTimeTicks;
                biObj.Open = biObj.Close = bidBi.Data[0] / 2 + bidBi.Data[1] / 2;
                biObj.High = 0;
                biObj.Low = biObj.Volume = bidBi.Volume;
                biObj.Ticks = bidBi.Ticks;
                res.push(new BaseInterval(biObj, historyParams.TimeFrameInfo.Periods));
            }
            else {
                const askBi = asks[askIndex];
                if (bidBi.FLeftTimeTicks == askBi.FLeftTimeTicks) {
                    biObj.LeftTimeTicks = bidBi.FLeftTimeTicks;
                    biObj.Open = bidBi.Data[BaseInterval.OPEN_INDEX] / 2 + askBi.Data[BaseInterval.OPEN_INDEX] / 2;
                    biObj.Close = bidBi.Data[BaseInterval.CLOSE_INDEX] / 2 + askBi.Data[BaseInterval.CLOSE_INDEX] / 2;
                    biObj.High = bidBi.Data[BaseInterval.HIGH_INDEX] / 2 + askBi.Data[BaseInterval.HIGH_INDEX] / 2;
                    biObj.Low = bidBi.Data[BaseInterval.LOW_INDEX] / 2 + askBi.Data[BaseInterval.LOW_INDEX] / 2;
                    biObj.Volume = bidBi.Volume;
                    res.push(new BaseInterval(biObj, historyParams.TimeFrameInfo.Periods));
                    askIndex++;
                }
            }
        }
        return res;
    }
    Notify(message) {
        this.ParseHistory(message, this.historyParams);
    }
    CancelHistoryRequest() {
        super.Disconnect();
    }
    setSupportedAggregations(supportedAggregations) {
        this.supportedAggregations = supportedAggregations;
    }
    isSupportedByServer(tfInfo) {
        const aggType = this.convertToServerAggregatedType(tfInfo.ChartDataType);
        if (aggType === HistoryAggregatedType.None)
            return false;
        const [periodType, periodValue] = this.convertToServerAggregatedPeriod(tfInfo.Periods);
        if (periodType == HistoryAggregatedPeriod.None)
            return false;
        for (const agg of this.supportedAggregations) {
            if (agg.getAggregatedType() === aggType &&
                agg.getAggregatedPeriod() == periodType &&
                agg.getAggregatedValue() == periodValue) {
                return true;
            }
        }
        return false;
    }
    convertToServerAggregatedType(chartDataType) {
        switch (chartDataType) {
            case ChartDataType.Default:
                return HistoryAggregatedType.Time;
            default:
                return HistoryAggregatedType.None;
        }
    }
    convertToServerAggregatedPeriod(period) {
        if (period % Periods.YEAR == 0) {
            return [HistoryAggregatedPeriod.None, period / Periods.YEAR];
        }
        else if (period % Periods.MONTH == 0) {
            return [HistoryAggregatedPeriod.PERIOD_MONTH, period / Periods.MONTH];
        }
        else if (period % Periods.WEEK == 0) {
            return [HistoryAggregatedPeriod.PERIOD_WEEK, period / Periods.WEEK];
        }
        else if (period % Periods.HOUR == 0) {
            return [HistoryAggregatedPeriod.PERIOD_HOUR, period / Periods.HOUR];
        }
        else if (period % Periods.MIN == 0) {
            return [HistoryAggregatedPeriod.PERIOD_MINUTE, period / Periods.MIN];
        }
        else {
            return [HistoryAggregatedPeriod.None, 0];
        }
    }
    getRealBarCount(count, period, isAggregatedByServer) {
        if (!isValidNumber(count)) {
            return undefined;
        }
        if (count > ProcessorWorker.MAX_BARS_TO_READ) {
            return ProcessorWorker.MAX_BARS_TO_READ;
        }
        if (isAggregatedByServer) {
            return count;
        }
        return this.getDownloadBarsCount(count, period);
    }
    getDownloadBarsCount(displayBarCount, period) {
        if (period === Periods.MIN || period === Periods.DAY || period === Periods.TIC) {
            return displayBarCount;
        }
        if (period >= Periods.YEAR && period % Periods.YEAR === 0) {
            return (period / Periods.YEAR) * displayBarCount * 366; // ?
        }
        if (period >= Periods.MONTH && period % Periods.MONTH === 0) {
            return (period / Periods.MONTH) * displayBarCount * 30; // ?
        }
        if (period >= Periods.WEEK && period % Periods.WEEK === 0) {
            return (period / Periods.WEEK) * displayBarCount * 7;
        }
        if (period >= Periods.DAY && period % Periods.DAY === 0) {
            return (period / Periods.DAY) * displayBarCount;
        }
        else if (period < 0) {
            throw new Error('getDownloadBarsCount::Not implemented for ticks');
        }
        else if (period % Periods.SECOND === 0) {
            throw new Error('getDownloadBarsCount::Not implemented for seconds');
        }
        else // minues aggregation
         {
            return period * displayBarCount;
        }
    }
    getBarInputParamsFromQuoteBarGroup(quoteBarGroup, period, historyType) {
        const time = quoteBarGroup.getTime();
        const open = quoteBarGroup.getOpen();
        const high = quoteBarGroup.getHigh();
        const low = quoteBarGroup.getLow();
        const close = quoteBarGroup.getClose();
        const askPrice = quoteBarGroup.getAsk();
        const askVolume = quoteBarGroup.getAskVolume();
        const bidPrice = quoteBarGroup.getBid();
        const bidVolume = quoteBarGroup.getBidVolume();
        const price = quoteBarGroup.getPrice();
        const volume = quoteBarGroup.getVolume();
        const openInt = quoteBarGroup.GetValue(FieldsFactory.FIELD_OPEN_INTEREST);
        const ticks = quoteBarGroup.GetValue(FieldsFactory.FIELD_TICKS);
        const isOpen = quoteBarGroup.getIsOpen();
        let sessionType = quoteBarGroup.GetValue(FieldsFactory.FIELD_SESSION_PERIOD_TYPE);
        if (sessionType > 128) {
            sessionType = 256 - sessionType;
        } // подробности в #101476
        const LastQuoteId = quoteBarGroup.GetLastQuoteID();
        const lastQuoteIdDate = quoteBarGroup.GetLastQuoteIdDate();
        const timeTicks = time.getTime();
        // DateTime dtMin = DateTime.MinValue;
        // DateTime dtMax = DateTime.MaxValue;
        //    QRecord record = list[i];
        //    if (record.datetime <= dtMin || record.datetime >= dtMax)
        //        continue;
        const biObj = new BaseIntervalInputParams();
        // var leftTime = curGr.getLeftTimeTicks();
        // biObj.LeftTimeTicks = leftTime ? leftTime + self.TIME_UTC_OFFSET : leftTime;
        // var rightTime = curGr.getRightTimeTicks();
        // biObj.FRightTimeTicks = rightTime ? rightTime + self.TIME_UTC_OFFSET : rightTime;
        // biObj.LeftTime = new Date(biObj.LeftTimeTicks);
        if (period === Periods.TIC) {
            // #region // ticks
            //        if (onlyMainSession && !TradingSessionBase.IsMainType(record.GetSession()))
            //            continue;
            switch (historyType) {
                case HistoryType.QUOTE_LEVEL1:
                case HistoryType.QUOTE_ASK:
                    biObj.LeftTimeTicks = timeTicks;
                    biObj.Open = bidPrice;
                    biObj.Close = askPrice;
                    // biObj.High = Number.NaN;
                    // biObj.Low = askVolume;
                    biObj.Volume = bidVolume;
                    break;
                case HistoryType.QUOTE_TRADES:
                    biObj.LeftTimeTicks = timeTicks;
                    biObj.Open = price;
                    biObj.Close = price;
                    // biObj.High = Number.NaN;
                    // biObj.Low = Number.NaN;
                    biObj.Volume = volume;
                    break;
                // это все режимиы для баров, строящихся по тикам (33тика и т.п)//
            }
            biObj.Ticks = 1;
            // #endregion
        }
        else if (period === Periods.MIN) {
            // #region // 1M
            //        if (onlyMainSession && !TradingSessionBase.IsMainType(record.GetSession()))
            //            continue;
            switch (historyType) {
                case HistoryType.DEFAULT:
                case HistoryType.QUOTE_LEVEL1:
                    biObj.LeftTimeTicks = timeTicks;
                    biObj.Open = open;
                    biObj.Close = close;
                    biObj.High = high;
                    biObj.Low = low;
                    biObj.Volume = ticks;
                    break;
                case HistoryType.QUOTE_ASK:
                    biObj.LeftTimeTicks = timeTicks;
                    biObj.Open = open;
                    biObj.Close = close;
                    biObj.High = high;
                    biObj.Low = low;
                    biObj.Volume = ticks;
                    break;
                case HistoryType.QUOTE_TRADES:
                    biObj.LeftTimeTicks = timeTicks;
                    biObj.Open = open;
                    biObj.Close = close;
                    biObj.High = high;
                    biObj.Low = low;
                    biObj.Volume = volume; // record.volume;
                    break;
            }
            biObj.Ticks = ticks;
            // #endregion
        }
        else {
            // #region // Day total
            switch (historyType) {
                case HistoryType.DEFAULT:
                case HistoryType.QUOTE_LEVEL1:
                    biObj.LeftTimeTicks = timeTicks;
                    biObj.Open = open;
                    biObj.Close = close;
                    biObj.High = high;
                    biObj.Low = low;
                    biObj.Volume = /* record.ticksPre + */ ticks;
                    break;
                case HistoryType.QUOTE_ASK:
                    biObj.LeftTimeTicks = timeTicks;
                    biObj.Open = open;
                    biObj.Close = close;
                    biObj.High = high;
                    biObj.Low = low;
                    biObj.Volume = /* record.ticksPre + */ ticks;
                    break;
                case HistoryType.QUOTE_TRADES:
                    biObj.LeftTimeTicks = timeTicks;
                    biObj.Open = open;
                    biObj.Close = close;
                    biObj.High = high;
                    biObj.Low = low;
                    biObj.Volume = volume; // record.volume;record.volumePre + record.volume + record.volumePost;
                    break;
            }
            biObj.Ticks = /* record.ticksPre + */ ticks;
            // #endregion
        }
        biObj.lastQuoteIdDate = lastQuoteIdDate;
        biObj.LastQuoteId = LastQuoteId;
        biObj.sessionType = sessionType;
        biObj.isOpen = isOpen;
        return biObj;
    }
}
const HistoryAggregatedType = {
    None: -1, // Not from server
    Time: 0 // At the current moment, only the Time (0) aggregation type is supported on the Server side.
};
Object.freeze(HistoryAggregatedType);
const HistoryAggregatedPeriod = {
    None: -1, // Not from server
    PERIOD_MINUTE: 2,
    PERIOD_HOUR: 3,
    PERIOD_WEEK: 5,
    PERIOD_MONTH: 6
};
Object.freeze(HistoryAggregatedPeriod);
